import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step1 } from '../../../../../shared/models/component-messages/simp_an/step1';
import { Annulation } from '../../models/Annulation';

@Component({
	selector: 'app-step1',
	templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {
	@Input() fnSimpleAnnulation: Annulation;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

	public current_uid_avisInitial = 'AvisInitialType';

	public step1 = new Step1();

	public rg1 = 'CTRL_IDWEB';

	constructor() {}

	public ngOnInit() {
		this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_idWebNames_json() }));
	}

	public getUid() {
		return this.uid;
	}

	public getUidAvisInitial() {
		return this.uid + '_SepSep_' + this.current_uid_avisInitial;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	  }

	getCtrl_idWebNames_json(): any {
	  return { idWeb: "_SepSep_Annulation_SepSep_AvisInitialType_SepAtt_idWeb" };
	}
}
